import React, { Component } from "react";
import ResizableRect from "./ResizableRect";
import "./Create-Product.css";
import "./Layer.css";

class Layer extends Component {
  constructor(props) {
    super();
    this.state = {
      //dynamic props
      index: props.index,
      key: props.key,
      width: props.width,
      height: props.height,
      top: props.top,
      left: props.left,
      rotateAngle: props.rotateAngle,
      Visible: props.Visible,
      minWidth: 0,

      //static props
      draggable: true,
      leftLimit: document.body.clientWidth / 2,
      topLimit: 0,
      rightLimit: document.body.clientWidth,
      bottomLimit: window.innerHeight / 2,
      widthLimit: 500,
      heightLimit: 500,
      position: "absolute",
      backgroundWidth: document.body.clientWidth / 2, //size of document.body.clientWidth
      windowWidth: document.body.clientWidth, //size of white board
      leftBorder: document.body.clientWidth / 2
    };
  }

  handleResize = (style, isShiftKey, type) => {
    // type is a string and it shows which resize-handler you clicked
    // e.g. if you clicked top-right handler, then type is 'tr'

    console.log("parent Update = " + this.props.parentUpdate);
    if (this.props.parentUpdate) {
      //alert('callback');
      this.setState(this.props);
      this.props.parentsCallback(this.state);
      return;
    }

    let { top, left, width, height } = style;

    if (top > this.state.topLimit && top < this.state.bottomLimit) {
      top = Math.round(top);
    }
    if (left > this.state.leftLimit && left < this.state.rightLimit) {
      left = Math.round(left);
    }
    width = Math.round(width);

    height = Math.round(height);

    this.setState({
      top,
      left,
      width,
      height
    });

    //leftLimit
    if (left < this.state.leftLimit) {
      this.setState({
        left: this.state.leftLimit
      });
    }

    //topLimit
    if (top < this.state.topLimit) {
      this.setState({
        top: this.state.topLimit
      });
    }

    //rightLimit
    if (left > this.state.rightLimit) {
      this.setState({
        left: this.state.rightLimit
      });
    }

    //bottomLimit
    if (top > this.state.bottomLimit) {
      this.setState({
        top: this.state.bottomLimit
      });
    }

    //widthLimit
    if (width > this.state.widthLimit) {
      this.setState({
        width: this.state.widthLimit
      });
    }

    //heightLimit
    if (height > this.state.heightLimit) {
      this.setState({
        height: this.state.heightLimit
      });
    }

    this.CheckStyle();
  };

  handleRotate = rotateAngle => {
    if (this.props.parentUpdate) {
      this.setState(this.props);
      this.props.parentsCallback(this.state);
      return;
    }

    this.setState({
      rotateAngle: rotateAngle
    });

    this.CheckStyle();
  };

  handleDrag = (deltaX, deltaY) => {
    console.log("parent pudate " + this.props.parentUpdate)
    if (this.props.parentUpdate) {
      this.setState(this.props);
      this.props.parentsCallback(this.state);
      return;
    }

    //Check if can drag
    if (this.state.draggable) {
      //Drag
      this.setState({
        left: this.state.left + deltaX,
        top: this.state.top + deltaY
      });

      //leftLimit
      if (this.state.left + deltaX < this.state.leftLimit) {
        this.setState({
          left: this.state.leftLimit
        });
      }

      //topLimit
      if (this.state.top + deltaY < this.state.topLimit) {
        this.setState({
          top: this.state.topLimit
        });
      }

      //rightLimit
      if (this.state.left + deltaX > this.state.rightLimit) {
        this.setState({
          left: this.state.rightLimit
        });
      }

      //bottomLimit
      if (this.state.top + deltaY > this.state.bottomLimit) {
        this.setState({
          top: this.state.bottomLimit
        });
      }

      this.CheckStyle();
    } //end if(this.state.draggable)
  }; //end handleDrag = (deltaX, deltaY) => {

  SetDrag = () => {
    this.setState({
      draggable: !this.state.draggable
    });
  };

  CheckStyle = () => {
    if (this.props.parentUpdate) {
      this.setState(this.props);
      this.props.parentsCallback(this.state);
      return;
    }

    //left checker
    let prevLeft = this.state.left;
    let prevBackground = this.state.backgroundWidth;
    let prevWindow = this.state.windowWidth;
    let prevLeftBorder = this.state.leftBorder;

    //top checker
    let prevTop = this.state.top;
    let prevTopBorder = this.state.topBorder;

    //size checker
    let prevWidth = this.state.width;
    let prevHeight = this.state.height;

    //Set Limits
    //left limit
    if (document.body.clientWidth > 600) {
      this.setState({
        leftLimit: document.body.clientWidth / 2 - this.state.width / 2, //  - (this.state.width/2 - Math.cos(this.state.rotateAngle * Math.PI/180)*this.state.width/2),// + (this.state.height/2 - Math.cos(this.state.rotateAngle* Math.PI/180)*this.state.height/2),
        topLimit: 92 - this.state.height / 2, // - (this.state.height/2 - Math.cos(this.state.rotateAngle * Math.PI/180) * this.state.width/2) - (this.state.width/2 - Math.cos(this.state.rotateAngle * Math.PI/180)*this.state.width/2),
        rightLimit: document.body.clientWidth - this.state.width / 2, // + (this.state.width/2 + Math.cos(this.state.rotateAngle * Math.PI/180)*this.state.width/2),// + (this.state.height/2 - Math.cos(this.state.rotateAngle* Math.PI/180)*this.state.height/2),
        bottomLimit:
          92 +
          document.body.clientWidth / 2 -
          this.state.height / 2 +
          (this.state.height / 2 -
            (Math.cos((this.state.rotateAngle * Math.PI) / 180) *
              this.state.height) /
              2), // + (this.state.width/2 - Math.cos(this.state.rotateAngle * Math.PI/180)*this.state.width/2),
        widthLimit: document.body.clientWidth - this.state.left,
        heightLimit: 92 + document.body.clientWidth / 2 - this.state.top,
        backgroundWidth: document.body.clientWidth / 2,
        windowWidth: document.body.clientWidth,
        leftBorder: document.body.clientWidth / 2,
        topBorder: 50
      });
    } else {
      this.setState({
        leftLimit: document.body.clientWidth / 2 - 150 - this.state.width, //)*(window.innerHeight/2)/this.state.backgroundWidth,
        topLimit: 10 - this.state.height,
        rightLimit: document.body.clientWidth / 2 + 150 - this.state.width / 2,
        bottomLimit: 10 + window.innerHeight / 2 + 150 - this.state.height,
        widthLimit:
          document.body.clientWidth / 2 +
          window.innerHeight / 4 -
          this.state.left,
        heightLimit:
          88 +
          document.body.clientWidth / 2 +
          window.innerHeight / 4 -
          this.state.top,
        backgroundWidth: 300,
        windowWidth: document.body.clientWidth,
        leftBorder: document.body.clientWidth / 2 - 150,
        topBorder: 10
      });
    } //end of if not width>600

    //resize width and height
    if (this.state.backgroundWidth != prevBackground) {
      this.setState({
        width: (prevWidth * this.state.backgroundWidth) / prevBackground,
        height: (prevHeight * this.state.backgroundWidth) / prevBackground
      });
    }

    //boundary rules
    //Set left
    if (this.state.left < this.state.leftLimit) {
      this.setState({
        left: this.state.leftLimit
      });
    }

    //Set Top
    if (this.state.top < this.state.topLimit) {
      this.setState({
        top: this.state.topLimit
      });
    }

    //set right
    if (this.state.left > this.state.rightLimit) {
      this.setState({
        left: this.state.rightLimit
      });
    }

    //set bottom
    if (this.state.top > this.state.bottomLimit) {
      this.setState({
        top: this.state.bottomLimit
      });
    }

    //resize left
    //resize left if window size changes
    if (prevWindow != this.state.windowWidth) {
      //left border adjustment

      //left ratio adjustment
      //let leftRatioAdjustment = (prevLeft - prevLeftBorder) * prevBackgroundWidth
      this.setState({
        left:
          (prevLeft - prevLeftBorder) *
            (this.state.backgroundWidth / prevBackground) +
          this.state.leftBorder
      });
    }

    //resize top
    if (this.state.backgroundWidth != prevBackground) {
      this.setState({
        top:
          (prevTop - prevTopBorder) *
            (this.state.backgroundWidth / prevBackground) +
          this.state.topBorder
      });
    }

    //prevents drag to right side
    //window.scroll(0, 0);

    //update parent component
    //props = this.state;
    this.state.index = this.props.index;
    this.state.key = this.props.key;
    this.props.parentsCallback(this.state);
    //alert('resize')
  }; //end Checkstyle


  componentWillMount() {
    this.CheckStyle();
  }
  componentDidMount() {
    this.CheckStyle();
    window.addEventListener("resize", this.CheckStyle);
    window.addEventListener("mousemove", this.scrollLeft);
    window.addEventListener('scroll', this.handleScroll);
  }

  render() {
    const { width, top, left, height, rotateAngle } = this.props;
    const { draggable } = this.state;
    return (
      <div>
        {/* BACKGROUND */}
        <div
          style={{
            position: "absolute",
            left:
              this.props.left +
              (this.props.borderThickness * this.state.backgroundWidth) / 500,
            top:
              this.props.top +
              (this.props.borderThickness * this.state.backgroundWidth) / 500,
            width: this.props.width,
            height: this.props.height,
            backgroundColor: this.props.backgroundColor,
            //opacity: this.props.opacity / 100.0,
            transform: "rotate(" + this.props.rotateAngle + "deg)",
            zIndex: 1
          }}
        ></div>

        {/* Image */}
        {!this.props.ratio && this.props.isImage && (
          <img
            src={this.props.imageUrl}
            style={{
              position: "absolute",
              left:
                left +
                (this.props.borderThickness * this.state.backgroundWidth) / 500,
              top:
                top +
                (this.props.borderThickness * this.state.backgroundWidth) / 500,
              width: width,
              height: height,
              transform: "rotate(" + rotateAngle + "deg)",
              opacity: this.props.pictureOpacity / 100.0,
              zIndex: 1
            }}
          />
        )}
        {this.props.ratio && this.props.isImage && (
          <img
            src={this.props.imageUrl}
            style={{
              position: "absolute",
              left:
                left +
                (this.props.borderThickness * this.state.backgroundWidth) / 500,
              top:
                top +
                (this.props.borderThickness * this.state.backgroundWidth) / 500,
              width: width,
              //height: height,
              transform: "rotate(" + rotateAngle + "deg)",
              opacity: this.props.pictureOpacity / 100.0,
              zIndex: 1
            }}
          />
        )}

        {/* BORDER */}
        <div
          style={{
            position: "absolute",
            left: this.props.left,
            top: this.props.top,
            width: this.props.width,
            height: this.props.height,
            transform: "rotate(" + this.props.rotateAngle + "deg)",
            //border: "1px solid #000000"
            border:
              (this.props.borderThickness * this.state.backgroundWidth) / 500 +
              "px solid " +
              this.props.borderColor,
            //opacity: this.props.opacity / 100.0,
            zIndex: 1
          }}
        ></div>

        {/* Text */}
        <div
          className="noselect"
          style={{
            position: "absolute",
            left:
              this.props.left +
              (this.props.borderThickness * this.state.backgroundWidth) / 500,
            top:
              this.props.top +
              (this.props.borderThickness * this.state.backgroundWidth) / 500 +
              ((100 - this.props.lineHeight) * this.props.fontSize) / 100,
            width: this.props.width,
            height: this.props.height,
            color: this.props.textColor,
            transform: "rotate(" + this.props.rotateAngle + "deg)",
            overflow: 'hidden',

            textAlign: this.props.textAlign,
            fontFamily: this.props.font,
            fontSize:
              (this.state.backgroundWidth * this.props.fontSize) / 500 + "px",
            fontWeight: this.props.fontWeight,
            fontStyle: this.props.fontStyle,
            textDecoration: this.props.textDecoration,
            lineHeight: this.props.lineHeight / 100 + "em",
            //lineHeight: (this.props.lineHeight * this.props.fontSize / 100) + 'px',            color: this.props.textColor,
            opacity: this.props.textOpacity / 100.0,
            zIndex: 1
          }}
        >
          {this.props.text}
        </div>

        {/* HIGHLIGHT */}
        {this.props.highlight && (
          <div
            className="Highlight"
            style={{
              position: "absolute",
              left:
                this.props.left +
                (this.props.borderThickness * this.state.backgroundWidth) / 500,
              top:
                this.props.top +
                (this.props.borderThickness * this.state.backgroundWidth) /
                  500 +
                ((100 - this.props.lineHeight) * this.props.fontSize) / 100,
              width: this.props.width,
              height: this.props.height,
              transform: "rotate(" + this.props.rotateAngle + "deg)",
              backgroundColor: "rgb(100, 100, 255)",
              opacity: 0.3,
              zIndex: 1
            }}
          ></div>
        )}

        {/* CONTROL */}
        {this.props.visible && (
          <ResizableRect
            className="absolute"
            draggable={draggable}
            left={
              left +
              (this.props.borderThickness * this.state.backgroundWidth) / 500
            }
            top={
              top +
              (this.props.borderThickness * this.state.backgroundWidth) / 500
            }
            width={width}
            height={height}
            rotateAngle={rotateAngle}
            //aspectRatio={this.props.ratio}
            // minWidth={10}
            // minHeight={10}
            zoomable="n, w, s, e, nw, ne, se, sw"
            // rotatable={true}
            // onRotateStart={this.handleRotateStart}
            onRotate={this.handleRotate}
            // onRotateEnd={this.handleRotateEnd}
            // onResizeStart={this.handleResizeStart}
            onResize={this.handleResize}
            // onResizeEnd={this.handleUp}
            // onDragStart={this.handleDragStart}
            onDrag={this.handleDrag}
            // onDragEnd={this.handleDragEnd}
          ></ResizableRect>
        )}
      </div>
    );
  }
}

export default Layer;
